module.exports = __webpack_public_path__ + "img/icon-search.25ec4835.svg";